import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import './Experience.css'

function Experience() {
  // useLocation() allows me to get the current URL so we can set an 'active' nav-link.
  const location = useLocation()
  const { pathname } = location
  const splitLocation = pathname.split('/')
  return (
    <div className='container'>
      <ul id='experience-nav' className='nav justify-content-center'>
        <li className='nav-item'>
          <Link
            to='/experience/dap'
            className={
              splitLocation[2] === 'dap' ? 'active nav-link' : 'nav-link'
            }>
            Digital Adoption
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            to='/experience/design'
            className={
              splitLocation[2] === 'design' ? 'active nav-link' : 'nav-link'
            }>
            Dev/Design/UX
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            to='/experience/other'
            className={
              splitLocation[2] === 'other' ? 'active nav-link' : 'nav-link'
            }>
            Law
          </Link>
        </li>
      </ul>
      <hr></hr>
      <Outlet />
    </div>
  )
}

export default Experience
